import tableStore from '../../store/TableStore';
import { WEvent } from './WEvent';

export class WBotWaitingHostEvent extends WEvent {
  pid: string;
  nick: string;
  club: string;
  uniqueId: string;
  amount: number;

  constructor(event: WBotWaitingHostEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  applyWebsocketChanges = (): Promise<void> =>
    tableStore.findActiveTableById(this.tableId).then(table => {
      table.addWaitingHostBot({
        pid: this.pid,
        nick: this.nick,
        club: this.club,
        uniqueId: this.uniqueId,
        amount: this.amount,
      });
      tableStore.changeFilterState();
    });
}
